import { createI18n } from 'vue-i18n';

export const availableLocales = [
  { code: 'en', label: 'English', icon: 'flag-gb' },
  { code: 'nl', label: 'Nederlands', icon: 'flag-nl', }
];
export const defaultLocale = 'nl';

const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: {},
  warnHtmlInMessage: 'off',
});

function deepMerge(target, source) {
    for (const key in source) {
      if (source[key] && typeof source[key] === 'object') {
        if (!target[key] || typeof target[key] !== 'object') {
          target[key] = {};
        }
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
    return target;
  }
  
  export async function loadLocaleMessages(locale) {
    if (Object.keys(i18n.global.getLocaleMessage(locale)).length > 0) {
      return locale;
    }
  
    try {
      const baseMessages = await import(`@/locales/${locale}.json`);
      let mergedMessages = baseMessages.default;
      const buildType = process.env.VUE_APP_TYPE; 
  
      if (buildType === 'developers' || buildType === 'bedrijfsdata') {
        try {
          const appMessages = await import(`@/locales/${locale}.${buildType}.json`);
          mergedMessages = deepMerge(mergedMessages, appMessages.default);
        } catch {
            // Do nothing.
            // console.warn(`No additional messages found for ${buildType} in locale ${locale}.`);
        }
      }
  
      i18n.global.setLocaleMessage(locale, mergedMessages);
      return locale;
    } catch (error) {
      await loadLocaleMessages(defaultLocale);
      return defaultLocale;
    }
  }

export function setI18nLanguage(locale) {
  i18n.global.locale = locale;
  document.querySelector('html').setAttribute('lang', locale);
}

export default i18n;